import React, { useEffect, useState } from 'react'
import { useQueryClient, useMutation } from 'react-query'
import Box from '@mui/system/Box'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'

const WarningDeleteModal = ({
  title,
  subtitle,
  children,
  deleteAPI = () => console.log('delete'),
  reactQueryKeys,
  successFunction = () => null,
  errorFunction = () => null,
  isOpen = false,
  closeModalFunction = () => null,
  disableErrorModal,
}) => {
  // delete modal
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
    closeModalFunction(false)
  }

  // error modal
  const [errorMessage, setErrorMessage] = useState('')
  const [isErrorModalOpen, setErrorModalOpen] = useState(false)
  const handleErrorOpen = () => {
    setErrorModalOpen(true)
  }
  const handleErrorClose = () => {
    setErrorModalOpen(false)
    closeModalFunction(false)
  }

  // API call here
  const queryClient = useQueryClient()
  const { isLoading, mutate } = useMutation((id) => deleteAPI(id), {
    onSuccess: async () => {
      if (reactQueryKeys) {
        reactQueryKeys.map(async (item) => {
          await queryClient.invalidateQueries(item)
          await queryClient.refetchQueries([item], { active: true })
        })
      }
      await successFunction()
      handleClose()
    },
    onError: async (e) => {
      await errorFunction()
      if (!disableErrorModal) {
        setErrorMessage(e?.data?.message)
        setModalOpen(false)
        handleErrorOpen()
      }
    },
  })
  const handleDelete = async (id) => {
    mutate(id)
  }

  useEffect(() => {
    setModalOpen(isOpen)
  }, [isOpen])

  return (
    <>
      <Box onClick={handleOpen}>{children}</Box>
      <AdxInfoModal
        variant="error"
        open={isModalOpen}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        title={title}
        subtitle={subtitle}
        footerButtons
        firstBtnLabel="Delete"
        firstBtnHandle={handleDelete}
        secondBtnLabel="Cancel"
        secondBtnHandle={handleClose}
      ></AdxInfoModal>

      {/* on error modal */}
      <AdxInfoModal
        variant="error"
        open={isErrorModalOpen}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleErrorClose()
          }
        }}
        handleClose={handleErrorClose}
        muiIcon="error"
        iconColor="error.main"
        title="An error occured"
        subtitle={errorMessage}
        footerButtons
        firstBtnLabel="Retry"
        firstBtnHandle={handleDelete}
        secondBtnLabel="Okay"
        secondBtnHandle={handleErrorClose}
      ></AdxInfoModal>
    </>
  )
}

export default WarningDeleteModal
